export const catalogItemLabel = (item, locale) => {
  const localized = item.aliases?.find(
    a => a.locale && locale.startsWith(a.locale)
  );
  return localized?.name || item.name;
};

// All searchable strings for a catalog item (base name + every alias), so the
// picker matches what the user types in any language, not just the shown label.
export const catalogItemKeywords = item =>
  [item.name, ...(item.aliases?.map(a => a.name) || [])].filter(Boolean);
